import React, { useState } from 'react'
import { makeStyles } from 'tss-react/mui'
import HomePageBannerItem from './HomePageBannerItem'
import { useEffectShopAccess, useShop } from '../../hooks'
import { ShopBannerResponse } from '../../models'
import SwiperCore, { Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useTypedSelector } from 'src/State/RootReducer'
import { getImageUrlBySize } from '../../utils'
import { ShopImageThumnbailSizes } from '../../types'

interface StyleProps {
  collapsedSidebar: boolean
}

const useStyles = makeStyles<StyleProps>()(() => ({
  swiperContainer: {
    width: '100%',
    overflow: 'hidden',
  },
  swiperItem: {
    width: '100%',
    overflow: 'hidden',
    flexShrink: 0,
  },
}))

const SLIDER_AUTOPLAY_TIME = 7000

const HomePageBanner: React.FC = () => {
  const { getShopBanners } = useShop()
  const collapsedSidebar = useTypedSelector(state => state.app.sidebarCollapsed)
  const selectedUserShopToken = useTypedSelector(state => state.shop.selectedUserData?.contextToken)
  const [banners, setBanners] = useState<ShopBannerResponse | null>(null)
  const { classes } = useStyles({ collapsedSidebar })
  SwiperCore.use([Autoplay])

  useEffectShopAccess(() => {
    getShopBanners()
      .then(result => {
        setBanners(result)
      })
      .catch(error => console.log(error))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedUserShopToken])

  return (
    <>
      {banners?.elements && (
        <Swiper
          pagination={{
            clickable: true,
          }}
          loop={true}
          observer={true}
          observeParents={true}
          slidesPerView={'auto'}
          autoplay={{ delay: SLIDER_AUTOPLAY_TIME }}
          className={classes.swiperContainer}
        >
          {banners?.elements
            .sort((a, b) => a.position - b.position)
            .map(banner => {
              const bannerUrl = banner.link
              const bannerText = banner.translated.text
              const bannerImage = getImageUrlBySize(banner.image.thumbnails, ShopImageThumnbailSizes.Banner)
              return (
                <>
                  {bannerImage && (
                    <SwiperSlide key={banner.position} className={classes.swiperItem}>
                      <HomePageBannerItem image={bannerImage} text={bannerText} url={bannerUrl} />
                    </SwiperSlide>
                  )}
                </>
              )
            })}
        </Swiper>
      )}
    </>
  )
}

export default HomePageBanner
